<template>
  <section class="bg-white py-8">
    <h2 id="yourpieces" class="uppercase tracking-wide no-underline hover:no-underline font-bold text-gray-800 text-xl mb-8"
          >
Your pieces          </h2>
              <div class="container mx-auto flex items-center flex-wrap pt-4 pb-12">

      <OwnerNft v-for="tokenId in tokens" :key="tokenId" :tokenId="tokenId" />

    </div>
  </section>

</template>

<script>

import OwnerNft from './OwnerNft.vue';

export default {
  name: "AccountCollection",
  props: {
    collectionId:{
      type: Number,
      required: true,
      default: 0
    },
    owner: {
      type: String,
      required: true
    }
  },
  async mounted(){

    this.numberOfTokens = await this.artburnDapp.methods.balanceOf(this.owner).call();
 
    for(let index=0; index < this.numberOfTokens; index++){
      let tokenId = await this.artburnDapp.methods.tokenOfOwnerByIndex(this.owner, index).call();
      let tokenCollectionId = await this.artburnDapp.methods.tokenCollection(tokenId).call();
      if(this.collectionId == tokenCollectionId){
        this.tokens.push(tokenId);
      }
    }
  },
  data: () => {
    return {
      tokens:[],
      numberOfTokens:0
    }
  },

  components: {
    OwnerNft
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iframe1by1 {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.iframe1by1 > iframe {
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.hover\:grow {
  transition: all 0.3s;
  transform: scale(1);
}

.hover\:grow:hover {
  transform: scale(1.02);
}
</style>
